var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWirelane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 75 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7102 56C18.4125 56 17.0979 55.6728 15.892 54.9847C12.2129 52.8839 10.9429 48.2158 13.0558 44.5577L36.5739 3.83592C38.6868 0.177838 43.3818 -1.08497 47.0609 1.01584C50.74 3.11612 52.01 7.78477 49.8971 11.4429L26.3789 52.1646C24.9587 54.6237 22.3713 56 19.7102 56Z",
    fill: "#FFEC2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67563 35.1402C6.37797 35.1402 5.06332 34.813 3.85748 34.1243C0.178914 32.024 -1.09115 27.3559 1.02173 23.6978L12.4921 3.83592C14.605 0.177838 19.2999 -1.08497 22.979 1.01584C26.6581 3.11665 27.9282 7.78477 25.8153 11.4429L14.3444 31.3043C12.9241 33.7634 10.3368 35.1402 7.67563 35.1402Z",
    fill: "#FFEC2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.792 56C42.4944 56 41.1797 55.6728 39.9739 54.9847C36.2948 52.8839 35.0247 48.2158 37.1376 44.5577L48.6085 24.6952C50.7208 21.0371 55.4158 19.7743 59.0954 21.8751C62.7745 23.9759 64.0446 28.6441 61.9317 32.3022L50.4608 52.1646C49.0405 54.6237 46.4532 56 43.792 56Z",
    fill: "#FFEC2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3187 15.2751C71.561 15.2751 75.0001 11.8556 75.0001 7.63754C75.0001 3.41944 71.561 0 67.3187 0C63.0764 0 59.6373 3.41944 59.6373 7.63754C59.6373 11.8556 63.0764 15.2751 67.3187 15.2751Z",
    fill: "#FFEC2D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.792 56C42.4944 56 41.1797 55.6728 39.9739 54.9847C36.2948 52.8839 35.0247 48.2158 37.1376 44.5577L48.6085 24.6952C50.7208 21.0371 55.4158 19.7743 59.0954 21.8751C62.7745 23.9759 64.0446 28.6441 61.9317 32.3022L50.4608 52.1646C49.0405 54.6237 46.4532 56 43.792 56Z",
    fill: "#FFEC2D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWirelane);
export default __webpack_public_path__ + "static/media/wirelane.8899a1f5.svg";
export { ForwardRef as ReactComponent };